module.exports = __webpack_public_path__ + "img/09.65c06ee7.jpg";